import React from 'react';
import { useAddBanner } from '../context/AddBannerContext';
import AddBannerStrip from './AddBannerStrip';

/**
 * Shows dynamic Add Banner when active; otherwise optional static fallback (original design).
 */
const AddBannerSlot = ({ displayOrder, fallback = null }) => {
  const banner = useAddBanner(displayOrder);

  if (banner?.imageSrc) {
    return <AddBannerStrip displayOrder={displayOrder} />;
  }

  return fallback;
};

export default AddBannerSlot;
